import React, { useState, useEffect } from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";
import axios from "axios";
import { useParams } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function BlogsPost() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [blogs, setBlogs] = useState([]); // Added to fetch all blogs
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch the specific blog
        const blogResponse = await axios.get(`${apiUrl}/api/blogs/${id}`);
        if (blogResponse.data.success) {
          setBlog(blogResponse.data.blog);
        } else {
          setError("Failed to fetch blog.");
        }

        // Fetch all blogs for related posts
        const allBlogsResponse = await axios.get(`${apiUrl}/api/blogs`);
        if (allBlogsResponse.data.success) {
          setBlogs(allBlogsResponse.data.blogs);
        } else {
          setError("Failed to fetch related blogs.");
        }
      } catch (err) {
        console.error("Fetch error:", err); // Added for debugging
        setError(err.response?.data?.message || "Error fetching data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!blog) return <div>Blog not found.</div>;

  return (
    <>
      <Head />
      {/* Start Breadcrumbs */}
      <section className="ak-about-hero-1">
        <img
          src={`${apiUrl}/${blog.featured_image}`} // Use blog's featured image as header
          className="about-hero-bg ak-bg object-cover"
          alt={blog.title}
          data-swiper-parallax={1152}
          onError={(e) => {
            e.target.src = "assets/img/bg/default.jpg"; // Fallback image if loading fails
          }}
        />
        <div className="container">
          <div className="about-hero-content">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p className="ak-section-subtitle animation-title" style={{ color: "white" }}>
                Blogs
              </p>
              <h2 className="ak-section-title animation-title" style={{ color: "white" }}>
                {blog.title} {/* Dynamic title */}
              </h2>
            </div>
            <a href="/" className="back-btn" style={{ color: "white" }}>
              Home / Discover / {blog.title}
            </a>
          </div>
        </div>
      </section>
      {/* End Breadcrumbs */}
      {/* Start Blog Details */}
      <section className="container">
        <div className="ak-height-60 ak-height-lg-50" />
        <div
          className="row justify-content-between flex-column-reverse flex-lg-row"
          id="containerAround"
        >
          <div className="col-lg-12">
            <div id="scrollGaleria">
              {/* <div className="blog-content-page">
                <a href="#" className="blog-card style-2">
                  <div className="blog-img">
                    <img
                      src={`${apiUrl}/${blog.featured_image}`}
                      alt={blog.title}
                      onError={(e) => {
                        e.target.src = "assets/img/default.jpg"; // Fallback image
                      }}
                    />
                  </div>
                  <div className="blog-details-info">
                    <div className="blog-meta-info">
                      <div className="blog-meta mb-2">
                        <span className="blog-author">
                          Admin / {new Date(blog.created_at).toLocaleDateString()}
                        </span>
                      </div>
                      <h3>{blog.title}</h3>
                    </div>
                  </div>
                </a>
              </div> */}
              <div className="ak-height-40 ak-height-lg-30" />
              <div
                dangerouslySetInnerHTML={{ __html: blog.content }} // Render content as HTML
              />
              <div className="ak-height-60 ak-height-lg-40" />


<div className="d-flex flex-lg-nowrap flex-wrap justify-content-between align-items-center gap-lg-5 gap-2">
  <p className="flex-shrink-0 fst-italic">Social Share:</p>
  <span className="ak-border-width color-black d-none d-lg-inline" />
  <div className="social-icon">
    {/* Facebook */}
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="icon color-1"
    >
      <svg
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="currentColor" // Use currentColor to inherit from CSS
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.675 0H1.325C0.593 0 0 0.593 0 1.325V22.675C0 23.407 0.593 24 1.325 24H12.82V14.706H9.692V11.084H12.82V8.413C12.82 5.313 14.713 3.625 17.479 3.625C18.804 3.625 19.942 3.724 20.274 3.778V6.848L18.77 6.849C17.145 6.849 16.928 7.436 16.928 8.408V11.084H20.16L19.712 14.706H16.928V24H22.675C23.407 24 24 23.407 24 22.675V1.325C24 0.593 23.407 0 22.675 0Z" />
      </svg>
    </a>
    {/* Twitter */}
    <a
      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(blog.title)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="icon color-1"
    >
      <svg
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M23.954 4.569C23.242 4.925 22.464 5.163 21.652 5.293C22.488 4.783 23.128 4.014 23.449 3.108C22.669 3.531 21.811 3.828 20.918 3.983C20.192 3.192 19.152 2.672 17.999 2.672C15.471 2.672 13.37 4.772 13.37 7.3C13.37 7.654 13.413 8.002 13.496 8.339C9.023 8.108 5.028 6.174 2.324 3.317C1.974 3.914 1.756 4.603 1.756 5.33C1.756 7.403 2.846 9.233 4.412 10.247C3.771 10.224 3.172 10.08 2.635 9.831C2.635 9.848 2.635 9.867 2.635 9.886C2.635 12.249 4.197 14.229 6.222 14.685C5.891 14.77 5.542 14.821 5.185 14.821C4.951 14.821 4.722 14.803 4.497 14.771C5.007 16.456 6.568 17.716 8.405 17.771C6.858 18.925 4.965 19.653 2.912 19.653C2.548 19.653 2.19 19.631 1.837 19.587C3.698 20.779 5.861 21.508 8.165 21.508C17.999 21.508 22.359 13.583 22.359 6.756C22.359 6.558 22.354 6.361 22.344 6.165C23.133 5.583 23.811 4.87 23.954 4.569Z" />
      </svg>
    </a>
    {/* LinkedIn */}
    <a
      href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=${encodeURIComponent(blog.title)}&summary=${encodeURIComponent(blog.content.substring(0, 100))}`}
      target="_blank"
      rel="noopener noreferrer"
      className="icon color-1"
    >
      <svg
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 0H5C2.239 0 0 2.239 0 5V19C0 21.761 2.239 24 5 24H19C21.761 24 24 21.761 24 19V5C24 2.239 21.761 0 19 0ZM8 19H5V10H8V19ZM6.5 8.3C5.6 8.3 4.9 7.6 4.9 6.7C4.9 5.8 5.6 5.1 6.5 5.1C7.4 5.1 8.1 5.8 8.1 6.7C8.1 7.6 7.4 8.3 6.5 8.3ZM19 19H16V14C16 12.9 15.1 12 14 12C12.9 12 12 12.9 12 14V19H9V10H12V11.3C12.7 10.4 14.1 9.7 15.6 9.7C18.3 9.7 19 11.5 19 13.8V19Z" />
      </svg>
    </a>
  </div>
</div>


              <div className="ak-height-125 ak-height-lg-50" />
         
            </div>
          </div>
        </div>
      </section>
      {/* End Blog Details */}
      <Foot />
    </>
  );
}

export default BlogsPost;